// https://github.com/facebook/jest/blob/fdb0afd5c0f2436b4545f49177bfdbb812e9a39b/packages/expect/src/matchers.ts#L165
export function isCloseTo(a, b, precision) {
    if (precision === void 0) { precision = 6; }
    if (a === Infinity && b === Infinity)
        return true;
    if (a === -Infinity && b === -Infinity)
        return true;
    var acceptableDiff = Math.pow(10, -precision) / 2;
    var actualDiff = Math.abs(a - b);
    return actualDiff < acceptableDiff;
}
/**
 * Determine whether a number can be considered an int allowing for floating point error
 */
export function isCloseToInt(a, precision) {
    if (precision === void 0) { precision = 6; }
    return isCloseTo(a % 1, 0, precision);
}
